import { suggestExercises } from 'exercises/src/uTheory.Skills/interactiveRegistry';
import type { ClientUserStore } from 'shared/src';
import { makeInt, skills } from 'shared/src/knowledge';

export function getRecommendedAndOptionalPracticesForSkills(
  skillIds: string[],
  clientUserStore: ClientUserStore
) {
  const allPractices = suggestExercises(skillIds)
    .map((practice) => ({
      ...practice,
      include: true,
    }))
    .sort((a, b) => {
      // Logic to put easier practices first:
      // -1 a first; 1 b first; 0 equal rank
      const aSkill = a.skills
        .map(makeInt)
        .filter((id): id is number => !!id)
        .map((skill) => skills.findIndex((s) => s.id === skill))
        .sort((x, y) => y - x)[0];
      const bSkill = b.skills
        .map(makeInt)
        .filter((id): id is number => !!id)
        .map((skill) => skills.findIndex((s) => s.id === skill))
        .sort((x, y) => y - x)[0];
      // return bSkill - aSkill;
      return (aSkill || 0) - (bSkill || 0);
    });

  // Other practices should include only those whose skills have all been completed:
  const otherPractices = allPractices.filter((practice) =>
    practice.skills.every(
      (skillId) => (clientUserStore.knowledgeProgress.skillsById[skillId]?.score || 0) > 99
    )
  );

  // Filter out others:
  let recommendedPractices = allPractices.filter((practice) => !otherPractices.includes(practice));

  // If we have more than 5 practices remaining, bump the advanced ones to other
  if (recommendedPractices.length > 5) {
    otherPractices.push(...recommendedPractices.slice(5));
  }

  // Filter out others, again:
  recommendedPractices = allPractices.filter((practice) => !otherPractices.includes(practice));

  // Only check the "include" checkmark box if every practice has been put in other practices.
  otherPractices.forEach((practice) => {
    practice.include = otherPractices.length === allPractices.length;
  });

  // Check all the recommended practices "include" checkmark boxes
  recommendedPractices.forEach((practice) => {
    practice.include = true;
  });

  return {
    recommendedPractices,
    otherPractices,
  };
}
